import styled from 'styled-components';
import { MapContainer } from 'react-leaflet';
import * as Constants from '../../../constants';

export const Page = styled(MapContainer)`
  height: 100%;
  width: 100%;
  background-color: ${Constants.colors.black};
`;
